import { ListFilter } from 'lucide-react';

export function EventLog({ log }) {
  return (
    <section className="panel event-log" aria-labelledby="log-heading">
      <header className="panel__header"><h2 id="log-heading">Журнал игры</h2><ListFilter size={17} /></header>
      <ol>
        {[...log].reverse().map((entry) => (
          <li key={entry.id} className={`event event--${entry.type}`}>
            <time>{new Date(entry.createdAt).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })}</time>
            <span>{entry.message}</span>
          </li>
        ))}
      </ol>
    </section>
  );
}
